import { Injectable } from '@angular/core';
import { Repo } from '@repos/repo.service';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { UserProfileState } from '@state/user-profile';
import type { TagModel } from './tags.models';

export interface MatterIdParams {
	matterId: string;
}

@Injectable({ providedIn: 'root' })
export class TagRepoService extends Repo<TagModel, MatterIdParams> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(pathParams: MatterIdParams): string {
		return CollectionPaths.business_matter_tags(
			this.businessId,
			pathParams.matterId,
		);
	}
}
